export default {
  errorContainer: {
    padding: '10px',
    margin: '5px'
  },
  endpoint: {
    fontSize: '9px'
  }
};
